import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AddControl from 'components/add_control';
import AddModal from './add_modal';
import Broker from 'bundles/apex/deals/show/brokers/broker';
import Card from 'bundles/apex/card';
import ContactDetails from 'bundles/backoffice/contacts/details';
import ContactIcon from 'bundles/backoffice/contacts/icon';
import ContactFormModalLink from 'bundles/apex/deals/show/contacts/contact/contact_form_modal_link';
import EmptyState from 'shared/empty_state';
import { faUser } from '@fortawesome/pro-solid-svg-icons';

export function OutsideBrokers({ deal }) {
  const [showAddModal, setShowAddModal] = useState();

  const commissions = deal.commissions.filter(commission => commission.outside);

  let children;
  if (commissions.length === 0) {
    children = <EmptyState header="No brokers have been added." icon={faUser} />;
  } else {
    children = commissions.map((commission, i) => (
      <Broker
        commission={commission}
        deletable
        icon={<ContactIcon contact={commission.contact} size="xl" />}
        index={i}
        key={i}
      >

        <ContactDetails
          contact={commission.contact}
          formModalLinkComponent={ContactFormModalLink}
          label="Outside Broker"
        />
      </Broker>
    ));
  }

  return <React.Fragment>
    <Card
      controls={<AddControl onClick={() => setShowAddModal(true)}>Add broker</AddControl>}
      label="Outside Brokers"
      verticalBody
    >
      {children}
    </Card>

    <AddModal show={showAddModal} onClose={() => setShowAddModal(false)} />
  </React.Fragment>;
}

OutsideBrokers.propTypes = {
  deal: PropTypes.shape({
    commissions: PropTypes.arrayOf(PropTypes.shape({
      contact: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
      outside: PropTypes.bool,
    })).isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(OutsideBrokers);
